import { render, staticRenderFns } from "./RxDetailsPDFInput.vue?vue&type=template&id=12838c57"
import script from "./RxDetailsPDFInput.vue?vue&type=script&lang=js"
export * from "./RxDetailsPDFInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports